<template>
    <div>
        <div class="col-xs-12 no-margin-bottom">

            <strong>
                <h4 class="text-center">{{translateLocal('Customer Information')}}</h4>
            </strong>
            <label for="fname">{{translateLocal('Firstname')}}</label>
            <input id="fname" type="text" v-model="customer.firstname" class="form-control" autocomplete="false">

            <label for="lastname">{{translateLocal('Lastname')}}</label>
            <input id="lastname" type="text" v-model="customer.lastname" class="form-control" autocomplete="false">
            <br>
            <label for="email">{{translateLocal('I would like to receive an invoice and a copy of the signed documents to the email address (no ads!)')}}</label>
            <div class=" alert alert-danger" v-if="!validateEmail">
                {{translateLocal('Please enter a valid address')}}
            </div>

            <input id="email" type="text" v-model="customer.email" class="form-control" autocomplete="false">
            <hr>

            <CustomerAddress v-model="customer" v-on:new_address="newAddress" v-bind:showOnly="false"></CustomerAddress>
        </div>

        <div class="col-xs-12 ">
            <button class="btn btn-primary"
                    v-model="customer.isOkEntry"
                    @click="saveEntry"
                    v-bind:disabled="!isEnabled"
            >
                OK
            </button>
        </div>
    </div>
</template>

<script>

    import translations from '../translations';
    import CustomerAddress from './CustomerAddress/CustomerAddress';

    export default {
        props: {
            customer:Object
        },
        data() {
            return {

            }
        },
        created(){
            this.isRealEmail();
        },
        methods: {
            saveEntry() {
                this.customer.isOkEntry=true;
                this.$emit('save');
            },
            translateLocal(key){
                let lang = this.customer.lang === null ? 'en': this.customer.lang ;
                if(translations[lang][key] !== undefined){
                    return translations[lang][key];
                }else{
                    return "___" + key;
                }
            },
            isRealEmail(){
                const regex = /^no.{0,5}@|^.{0,2}@/i;
                let m;
                if ((m = regex.exec(this.customer.email)) !== null) {
                    m.forEach((match, groupIndex) => {
                        this.customer.email = "";
                    });
                }
            },
            newAddress(newAddressData) {
                this.customer.address.push(Object.assign({}, newAddressData));
                this.customer.address_selected_id = newAddressData.id;
            },
        },
        computed : {
            isEnabled(){
                if(this.customer.firstname && this.customer.lastname && this.validateEmail){
                    return true;
                }
                return false;
            },
            validateEmail() {
                if(this.customer.email){
    					const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
						return re.test(String(this.customer.email).toLowerCase());
                }else{
                    return true;
                }
            }
        },
        watch:{
			"customer.email"(value){
				this.customer.email = value.toLowerCase();
			}
        },
        components : {
            CustomerAddress
        }
    }
</script>


